<ng-container
  *ngIf="
    isProcessDefinitionsLoading;
    then showProcessLoadingTemplate;
    else showProcessTemplate
  "
></ng-container>
<ng-template #showProcessLoadingTemplate>
  <mat-spinner class="adf-start-process-loading"></mat-spinner>
</ng-template>
<ng-template #showProcessTemplate>
  <ng-container *ngIf="hasProcessDefinitions(); else showEmptyTemplate">
    <div class="adf-start-process">
      <div class="adf-title">
        {{ 'ADF_PROCESS_LIST.START_PROCESS.FORM.TITLE' | translate }}
      </div>
      <div class="content">
        <div class="adf-start-process-definition-container">
          <mat-form-field
            class="adf-process-input-container"
            [floatLabel]="'always'"
          >
            <mat-label>{{
              'ADF_PROCESS_LIST.START_PROCESS.FORM.LABEL.TYPE' | translate
            }}</mat-label>
            <input
              type="text"
              matInput
              [formControl]="processDefinitionInput"
              [matAutocomplete]="auto"
              id="processDefinitionName"
              #inputAutocomplete
            />
            <div class="adf-process-input-autocomplete">
              <mat-autocomplete
                #auto="matAutocomplete"
                id="processDefinitionOptions"
                [displayWith]="displayFn"
              >
                <mat-option
                  *ngFor="
                    let processDef of filteredProcessesDefinitions$ | async
                  "
                  [value]="processDef.name"
                  (click)="processDefinitionSelectionChanged(processDef)"
                  (keyup)="processDefinitionSelectionChanged(processDef)"
                >
                  {{ processDef.name }}
                </mat-option>
              </mat-autocomplete>
              <ng-container
                *ngIf="
                  !isProcessDefinitionsLoading;
                  else showProcessDefLoadingTemplate
                "
              >
                <button
                  id="adf-select-process-dropdown"
                  *ngIf="showSelectProcessDropdown"
                  mat-icon-button
                  (click)="displayDropdown($event)"
                  [disabled]="isDropdownDisabled()"
                >
                  <mat-icon>arrow_drop_down</mat-icon>
                </button>
              </ng-container>
              <ng-template #showProcessDefLoadingTemplate>
                <mat-spinner
                  id="adf-select-process-spinner"
                  [diameter]="20"
                ></mat-spinner>
              </ng-template>
            </div>
          </mat-form-field>
        </div>

        <ng-container
          *ngIf="
            !isProcessDefinitionsLoading;
            else showStartFormLoadingTemplate
          "
        >
          <ng-container
            *ngIf="isProcessDefinitionSelected(); else emptyProcessDefTemplate"
          >
            <ng-container *ngIf="hasStartForm()">
              <adf-start-form
                #startForm
                [data]="values"
                [disableStartProcessButton]="
                  processNameInput.invalid || processStarted
                "
                [processDefinitionId]="selectedProcessDef.id"
                (outcomeClick)="onOutcomeClick($event)"
                [showRefreshButton]="false"
                [fieldValidators]="fieldValidators"
              >
                <button
                  adf-form-custom-button
                  mat-button
                  (click)="cancelStartProcess()"
                  id="cancel_process"
                >
                  {{
                    'ADF_PROCESS_LIST.START_PROCESS.FORM.ACTION.CANCEL'
                      | translate
                      | uppercase
                  }}
                </button>
              </adf-start-form>
            </ng-container>
          </ng-container>
          <ng-template #emptyProcessDefTemplate>
            <adf-empty-content
              class="adf-start-process-empty-template"
              [icon]="'assessment'"
              [title]="
                'ADF_PROCESS_LIST.START_PROCESS.NO_PROCESS_DEF_SELECTED'
                  | translate
              "
            >
            </adf-empty-content>
          </ng-template>
        </ng-container>
        <ng-template #showStartFormLoadingTemplate>
          <mat-spinner class="adf-start-process-loading"></mat-spinner>
        </ng-template>
      </div>
    </div>
  </ng-container>
  <ng-template #showEmptyTemplate>
    <adf-empty-content
      class="adf-start-process-empty-template-no-defination"
      [icon]="'assessment'"
      [subtitle]="
        'ADF_PROCESS_LIST.START_PROCESS.NO_PROCESS_DEFINITIONS' | translate
      "
    >
    </adf-empty-content>
  </ng-template>
</ng-template>

<mat-dialog-actions class="wk-process-actions" *ngIf="!hasStartForm()">
  <div class="mat-content-actions">
    <button
      mat-button
      *ngIf="!hasStartForm()"
      (click)="cancelStartProcess()"
      id="cancel_process"
    >
      {{
        'ADF_PROCESS_LIST.START_PROCESS.FORM.ACTION.CANCEL'
          | translate
          | uppercase
      }}
    </button>
    <button
      color="primary"
      mat-button
      *ngIf="!hasStartForm()"
      [disabled]="!validateForm()"
      (click)="startProcess()"
      data-automation-id="btn-start"
      id="button-start"
      class="btn-start"
    >
      {{
        'ADF_PROCESS_LIST.START_PROCESS.FORM.ACTION.START'
          | translate
          | uppercase
      }}
    </button>
  </div>
</mat-dialog-actions>
